import React from 'react';
import { useNavigate } from 'react-router-dom';
import iconLike from '../../assets/figma-home/icon-like.svg';
import { useWishlist } from '../../context/WishlistContext';
import { useLanguage } from '../../context/LanguageContext';
import { localizeProduct } from '../../utils/localizeProduct';

// Pixory-style product card for the Home.js rows only — white card with a
// gray lowercase series label + "e re" pill in the header, a large centered
// cover image, then name/price and a dark pill CTA. Not used by the
// Photobooks catalog (that page keeps FigmaProductCard).
const PixoryHomeProductCard = ({ product: rawProduct, isNew, label }) => {
  const navigate = useNavigate();
  const { isWishlisted, toggleWishlist } = useWishlist();
  const { t, lang } = useLanguage();
  const product = localizeProduct(rawProduct, lang);
  const image = product.imageUrls && product.imageUrls[0];
  // Second product photo, shown on hover (Pixory-style). Cards with a single
  // photo simply never fade — no placeholder needed.
  const hoverImage = product.imageUrls && product.imageUrls[1];
  const liked = isWishlisted(product.id);
  const goToProduct = () => navigate(`/product/${product.id}`);

  return (
    <div className="pixory-card" onClick={goToProduct}>
      <div className="pixory-card-head">
        {label && <p className="pixory-card-label">{label}</p>}
        {isNew && <span className="pixory-card-tag">{t('card.new')}</span>}
        <button
          type="button"
          className={`pixory-card-like ${liked ? 'active' : ''}`}
          aria-label={liked ? t('card.removeWish') : t('card.addWish')}
          onClick={(e) => { e.stopPropagation(); toggleWishlist({ id: product.id, name: product.name, price: product.price, image }); }}
        >
          <img src={iconLike} alt="" />
        </button>
      </div>
      <div className={`pixory-card-image ${hoverImage ? 'has-alt' : ''}`}>
        {image && <img src={image} alt={product.name} loading="lazy" className="pixory-card-cover" />}
        {hoverImage && (
          <img src={hoverImage} alt="" loading="lazy" className="pixory-card-cover pixory-card-cover-alt" />
        )}
      </div>
      <div className="pixory-card-info">
        <div className="pixory-card-meta">
          <p className="pixory-card-name">{product.name}</p>
          <p className="pixory-card-price">€{product.price?.toFixed(2)}</p>
        </div>
        {product.shortDescription && (
          <p className="pixory-card-desc">{product.shortDescription}</p>
        )}
        <button
          type="button"
          className="pixory-card-btn"
          onClick={(e) => { e.stopPropagation(); goToProduct(); }}
        >
          {t('card.orderNow')}
        </button>
      </div>
    </div>
  );
};

export default PixoryHomeProductCard;
